var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5281 16.0029C21.9984 16.0029 21.5719 16.4295 21.5719 16.9592V21.5717H2.42812V16.9592C2.42812 16.4295 2.00156 16.0029 1.47187 16.0029C0.942187 16.0029 0.515625 16.4295 0.515625 16.9592V22.5279C0.515625 23.0576 0.942187 23.4842 1.47187 23.4842H22.5281C23.0578 23.4842 23.4844 23.0576 23.4844 22.5279V16.9592C23.4844 16.4295 23.0578 16.0029 22.5281 16.0029Z",
    fill: "#39695B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2957 17.1377C11.8348 17.6814 12.4957 17.3814 12.6973 17.1377L18.1957 11.2221C18.5567 10.833 18.5332 10.2283 18.1442 9.86738C17.7551 9.50644 17.1504 9.52988 16.7942 9.91894L12.9551 14.0486V1.61738C12.9551 1.0877 12.5286 0.661133 11.9989 0.661133C11.4692 0.661133 11.0426 1.0877 11.0426 1.61738V14.0533L7.20355 9.92363C6.84261 9.53457 6.23793 9.51582 5.84886 9.87207C5.4598 10.233 5.44105 10.8377 5.7973 11.2268L11.2957 17.1377Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGreen);
export default __webpack_public_path__ + "static/media/download-green.f917c13e92adfea89d0692c0b7f8dce1.svg";
export { ForwardRef as ReactComponent };